<template>
<div>
    <v-server-table ref="recognitionsTable" url="/employees/recognition-list" :columns="columns" :options="options">
        <template slot="employee_recognition_id" slot-scope="props">
            <router-link :to="`/employees/recognition/view/${props.row.employee_recognition_id}`" class="btn btn-sm btn-secondary">
                View
            </router-link>
        </template>
        <template slot="creator_first_name" slot-scope="props">
            <user-name :user="creator(props.row)" />
        </template>
        <router-link :to="`/employees/view/${props.row.employee_id}`" slot="employee_name" slot-scope="props">
            {{ props.row.EmployeeNumber }} - {{ props.row.employee_first_name }} {{ props.row.employee_last_name }}
        </router-link>
        <template slot="JobsiteName" slot-scope="props">
            <span v-if="props.row.JobsiteName">{{ props.row.JobsiteNumber }} - {{ props.row.JobsiteName }}</span>
            <span v-else></span>
        </template>
        <template slot="recognition_date" slot-scope="props">
            {{ props.row.recognition_date | moment("MM/DD/YYYY") }}
        </template>
        <template slot="status" slot-scope="props">
            <span v-if="props.row.status == 'Open'" class="badge badge-danger">{{ props.row.status }}</span>
            <span v-if="props.row.status == 'Closed'" class="badge badge-success">{{ props.row.status }}</span>
        </template>
        <template slot="child_row" slot-scope="props">
            <div class="mb-2">
                <div class="text-muted">Explanation:</div>
                <template v-if="!props.row.explanation">
                    --
                </template>
                <template v-else>
                    {{ props.row.explanation }}
                </template>
            </div>
            <div class="mb-2">
                <div class="text-muted">General Comments:</div>
                <template v-if="!props.row.general_comments">
                    --
                </template>
                <template v-else>
                    {{ props.row.general_comments }}
                </template>
            </div>

        </template>
    </v-server-table>
</div>
</template>

<script>
export default {
    props: ['timeFilter'],

    data: function() {
        return {
            options: {
                headings: {
                    employee_recognition_id: 'Actions',
                    employee_name: 'Employee',
                    craft: 'Craft',
                    creator_first_name: 'Creator',
                    recognition_name: 'Recognition Type',
                    super_last_name: 'Superintendent',
                    foreman_last_name: 'Foreman',
                    JobsiteName: 'Jobsite',
                    DivisionName: 'Division',
                    recognition_date: 'Date',
                    status: 'Status',
                },
                orderBy: {
                    ascending: false,
                    column: 'employee_recognitions.recognition_date',
                },
                responseAdapter: (response) => {
                    //Emit the count
                    this.$emit('recognitionListCount', response.data.count);

                    //Send it
                    return response.data;
                },
                requestAdapter: (data) => {
                    //Set the filters
                    data.filters = {
                        'employee_recognitions.recognition_date': this.timeFilter.toLowerCase(),
                    };

                    this.getPreviousData();

                    //Send it
                    return data;
                },
                uniqueKey: 'employee_recognition_id',
            },
            columns: [
                'employee_recognition_id',
                'employee_name',
                'craft',
                'creator_first_name',
                'recognition_name',
                'super_last_name',
                'foreman_last_name',
                'JobsiteName',
                'DivisionName',
                'recognition_date',
                'status',
            ]
        }
    },

    methods: {
        creator(row) {
            return {
                FirstName: row.creator_first,
                LastName: row.creator_last,
                deleted_at: row.creator_deleted_at,
            };
        },

        getPreviousData: function() {
            this.$http.get('/employees/recognition-list', {'filters': {'employee_recognitions.recognition_date': 'prev_'+this.timeFilter.toLowerCase()}})
            .then(response => {
                this.$emit('prevRecognitionListCount', response.data.count);
            })
            .catch(err => {

            })
            .then(() => {

            });
        },
    },
}
</script>
